module.exports = __webpack_public_path__ + "static/media/awais.1d658787.jpeg";